module.exports = __webpack_public_path__ + "static/media/banco-do-brasil.8041c7b5.webp";